import { useMemo } from 'react';
import { useAppTheme } from '@/contexts/AppThemeContext';

export interface RechartsThemeColors {
  textColor: string;
  textSecondary: string;
  gridColor: string;
  tooltipBackground: string;
  tooltipBorder: string;
}

/**
 * Theme-aware colors for Recharts (Legend, XAxis, YAxis, Tooltip, CartesianGrid).
 * Use with useAppTheme so labels and legends are readable in both light and dark mode.
 */
export function useRechartsTheme(): RechartsThemeColors {
  const { theme } = useAppTheme();
  return useMemo<RechartsThemeColors>(() => {
    const isDark = theme === 'dark';
    return {
      textColor: isDark ? '#D1D5DB' : '#374151',
      textSecondary: isDark ? '#9CA3AF' : '#6B7280',
      gridColor: isDark ? '#374151' : '#E5E7EB',
      tooltipBackground: isDark ? '#111827' : '#FFFFFF',
      tooltipBorder: isDark ? '#374151' : '#E5E7EB',
    };
  }, [theme]);
}
